// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPlaidInstitutionDto } from './IPlaidInstitutionDto';
import {
    IPlaidInstitutionDtoFromJSON,
    IPlaidInstitutionDtoFromJSONTyped,
    IPlaidInstitutionDtoToJSON,
    IPlaidInstitutionDtoToJSONTyped,
} from './IPlaidInstitutionDto';
import type { IPlaidAccountDto } from './IPlaidAccountDto';
import {
    IPlaidAccountDtoFromJSON,
    IPlaidAccountDtoFromJSONTyped,
    IPlaidAccountDtoToJSON,
    IPlaidAccountDtoToJSONTyped,
} from './IPlaidAccountDto';

/**
 * 
 * @export
 * @interface IPlaidMetadataDto
 */
export interface IPlaidMetadataDto {
    /**
     * 
     * @type {string}
     * @memberof IPlaidMetadataDto
     */
    link_session_id?: string;
    /**
     * 
     * @type {IPlaidInstitutionDto}
     * @memberof IPlaidMetadataDto
     */
    institution?: IPlaidInstitutionDto;
    /**
     * 
     * @type {Array<IPlaidAccountDto>}
     * @memberof IPlaidMetadataDto
     */
    accounts: Array<IPlaidAccountDto>;
}

/**
 * Check if a given object implements the IPlaidMetadataDto interface.
 */
export function instanceOfIPlaidMetadataDto(value: object): value is IPlaidMetadataDto {
    if (!('accounts' in value) || value['accounts'] === undefined) return false;
    return true;
}

export function IPlaidMetadataDtoFromJSON(json: any): IPlaidMetadataDto {
    return IPlaidMetadataDtoFromJSONTyped(json, false);
}

export function IPlaidMetadataDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPlaidMetadataDto {
    if (json == null) {
        return json;
    }
    return {
        
        'link_session_id': json['link_session_id'] == null ? undefined : json['link_session_id'],
        'institution': json['institution'] == null ? undefined : IPlaidInstitutionDtoFromJSON(json['institution']),
        'accounts': ((json['accounts'] as Array<any>).map(IPlaidAccountDtoFromJSON)),
    };
}

export function IPlaidMetadataDtoToJSON(json: any): IPlaidMetadataDto {
    return IPlaidMetadataDtoToJSONTyped(json, false);
}

export function IPlaidMetadataDtoToJSONTyped(value?: IPlaidMetadataDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'link_session_id': value['link_session_id'],
        'institution': IPlaidInstitutionDtoToJSON(value['institution']),
        'accounts': ((value['accounts'] as Array<any>).map(IPlaidAccountDtoToJSON)),
    };
}

